import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Grid from "@mui/material/Grid2";
import { useConfigurationObjectScrolling } from "../../NavigationState/useConfigurationScrolling";
import { SubstructureContent } from "./SubstructureContent";
import { SubstructureInstanceButtons } from "./SubstructureInstanceButtons";
import { SubstructureLabel } from "./SubstructureLabel";
import { SubstructureScrollRestoreBehavior } from "./SubstructureScrollRestoreBehavior";
import { useSubstructureExpansionState } from "./useSubstructureExpansionState";
import { useSubstructureLayout } from "./useSubstructureLayout";
/**
 * Single instance of a sub configuration
 * @param props
 * @returns
 */
export function SubstructureEmbeddedInstance(props) {
    const { defaultExpanded } = useSubstructureLayout();
    const { substructure } = props;
    const { isExpanded, setIsExpanded } = useSubstructureExpansionState({
        defaultExpanded,
        path: props.substructure.path,
        id: props.substructure.id,
    });
    const elementRef = useConfigurationObjectScrolling({
        configurationObject: substructure,
    });
    const summary = (_jsxs(Grid, { container: true, alignItems: "center", width: "100%", children: [_jsxs(Grid, { size: { sm: 6 }, children: [_jsx(SubstructureLabel, { substructure: substructure }), _jsx(SubstructureScrollRestoreBehavior, { instancePath: substructure.path })] }), _jsx(Grid, { size: { sm: 6 }, children: _jsx(SubstructureInstanceButtons, { substructure: substructure }) })] }));
    const content = isExpanded ? (_jsx(SubstructureContent, { substructure: substructure })) : null;
    return (_jsx(Fragment, { children: _jsxs(Accordion, { ref: elementRef, expanded: isExpanded, onChange: () => setIsExpanded(!isExpanded), slotProps: { transition: { unmountOnExit: true } }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, {}), component: "div", children: summary }), _jsx(AccordionDetails, { children: content })] }) }));
}
SubstructureEmbeddedInstance.displayName = "SubstructureEmbeddedInstance";
//# sourceMappingURL=SubstructureEmbeddedInstance.js.map